import React from 'react'
import images from 'assets/img'
import CashbackHeader from './CashbackHeader'
import { withTranslation } from 'react-i18next'

export default withTranslation()(function EmptyCashback({t}) {
  return (
    <section className="w-full bg-white p-5 rounded-xl mb-5 shadow-sm">
      <CashbackHeader />

      <div className="w-full h-80 flex flex-col items-center justify-center">
        <div className="w-24 h-24 flex justify-center mb-7 items-center rounded-full bg-border-lines">
          <img src={images.Cashback} alt="" className="w-16 h-16" />
        </div>
        
        <p className="text-placeholder w-3/5 mx-auto text-center">{ t('settings.cashback.empty') }</p>
      </div>
    </section>
  )
})